import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {Offer} from '../types';

export const columns = [
    {
        title: I18n.get('Name'),
        width: '1fr',
        render: (item: Offer) => <NavLink to={`/offers/${item.id}`}>{item.name}</NavLink>,
    },
    {
        title: I18n.get('URL'),
        width: '1fr',
        render: (item: Offer) => item.url,
    },
    {
        title: I18n.get('Phone'),
        width: '1fr',
        render: (item: Offer) => item.phone,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: Offer) => formatTimestamp(item.created as string),
    },
];
